import BaseStyle from '@primevue/core/base/style';

var classes = {
  root: 'p-inputgroupaddon'
};
var InputGroupAddonStyle = BaseStyle.extend({
  name: 'inputgroupaddon',
  classes: classes
});

export { InputGroupAddonStyle as default };
//# sourceMappingURL=index.mjs.map
